import { colorMap, type StatusColor } from '@/components/shared/types'

export const getStatusColorByHex = (hexColor: string): StatusColor => {
  const normalizedHex = hexColor.toLowerCase()

  return (
    (Object.entries(colorMap).find((colorItem) => colorItem[1].toLowerCase() === normalizedHex)?.[0] as StatusColor) ||
    'orange'
  )
}
